// test16
(16 && 0);
